import { createContext } from "react";

export const InSiteContext = createContext("");
